// src/views/words-lists/WordsListsView.tsx
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Spin, Tabs,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import withTagManager from '../../hooks/withTagManager';
import styles from './WordsListsView.module.less';
import { getIsLoadingWordsListList, getListOfWordsList } from './slice/selectors';
import { fetchWordsListPage } from './slice/actions';
import FolderTreeView from './FolderTreeView';
import ClassicListView from './ClassicListView';
import AddWordsListModal from './modals/AddWordsListModal';

const { TabPane } = Tabs;

const WordsListsView: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loading = useSelector(getIsLoadingWordsListList);
  const lists = useSelector(getListOfWordsList);
  const [activeTab, setActiveTab] = useState<string>('folders');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const hasInitiallyFetchedRef = useRef(false);

  const hideAddModal = useCallback(() => { // ✅ Dodaj useCallback
    setIsModalVisible(false);
  }, []);

  useEffect(() => {
    if (!hasInitiallyFetchedRef.current) {
      hasInitiallyFetchedRef.current = true;
      dispatch(fetchWordsListPage(1));
    }
  }, [dispatch]);

  // ✅ Zmemoizuj TabPane content
  const folderTabContent = useMemo(() => {
    if (loading && lists.length === 0) {
      return (
        <div className={styles.loadingContainer}>
          {/* <Skeleton active paragraph={{ rows: 10 }} /> */}
          <Spin />
        </div>
      );
    }

    return <FolderTreeView />;
  }, [loading, lists.length]);

  const classicTabContent = useMemo(() => (
    <ClassicListView />
  ), []);

  return (
    <>
      <AddWordsListModal isVisible={isModalVisible} hideModal={hideAddModal} />

      <div className={styles.mainWrapper}>
        <div className={styles.contentContainer}>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            className={styles.tabs}
            destroyInactiveTabPane={false}
          >
            <TabPane
              tab={<span> {t('words-list:lists.tabs.folders')} </span>}
              key="folders"
              className={styles.tabPane}
            >
              {folderTabContent}
            </TabPane>

            <TabPane
              tab={<span> {t('words-list:lists.tabs.lists')} </span>}
              key="classic"
              className={styles.tabPane}
            >
              {classicTabContent}
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default React.memo(withTagManager(WordsListsView));
